import React from 'react';
import Card from '../../../Helper/CardWrapper/cardWrapper'
import ContentGrid from '../../../Helper/gridWrapper/gridWrapper';
import Grid from "@material-ui/core/Grid";

class Menu extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    render() {
        return (
            <div style={{ padding: "0px 20px 0px 0px" }}>
                <ContentGrid
                    content={
                        <Card
                            content={
                                <Grid>
                                    <div
                                        style={{
                                            display: "flex",
                                            background: "white",
                                            height: "calc(100vh - 170px)",
                                            overflow: "auto",
                                            justifyContent: "center",
                                            marginTop: "0px -12px 0px -12px",
                                        }}
                                    >
                                        <iframe
                                            src="https://www.ubmefood.com/menuedit/"
                                            width="100%"
                                            height="100%"
                                            display="initial"
                                            position="relative"
                                            sandbox="allow-scripts allow-same-origin allow-presentation allow-forms"
                                        />
                                    </div>
                                </Grid>
                            }
                            CardContentProps={{
                                style: {borderTop: '1px solid #ddd'}
                            }}
                        />
                    }
                />
            </div>
        )
    }
}

export default Menu;